
import { Component, Vue, Prop, Watch, Emit, Model } from 'vue-property-decorator'
import Agreement from '@xt/mobile/components/business/course/agreement.vue'

@Component({
  components: {
    Agreement
  }
})
export default class AgreementModal extends Vue {
  @Prop({ required: true }) visible: boolean
  @Prop({ required: true }) type: string
  @Prop({ required: true }) id: string

  get agreementData() {
    return {
      original: {
        productInfo: {
          id: this.id
        }
      }
    }
  }

  @Emit('close')
  onClose() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
